import config from "./config";

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    '359065791766-f1hunj8q731vgct1d89etsv4sef50cfa.apps.googleusercontent.com';
const NODE_BACKEND_URL = config.SERVER_BASE_URL
// Use relative paths for local dev (CRA proxy forwards /api → Express at 4001)
// Production uses the API gateway URL
const isLocalDev = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const PYTHON_BACKEND_URL = isLocalDev ? config.SERVER_BASE_URL : 'https://slam-gateway-4kyai23a.uc.gateway.dev'
const ADK_BACKEND_URL = 'https://agui-adk-359065791766.us-central1.run.app'
const AGUI_RUNTIME = 'https://slams-agui-app-359065791766.us-central1.run.app'
const APP_ID = '359065791766'
const DEVELOPER_KEY = process.env.REACT_APP_GOOGLE_PICKER_KEY || ''
const WIDGET_BACKEND_URL = process.env.REACT_APP_WIDGET_BACKEND_URL || 'https://widget-server-359065791766.us-central1.run.app';

const positionsFilter = [
    // "All",
    "1B",
    "2B",
    "3B",
    "C",
    "C-DH",
    "C-UT",
    "CF",
    "DH",
    "IF",
    "IF-C",
    "IF-OF",
    "IF-UT",
    "LF",
    "OF",
    "OF-C",
    "P",
    "P-IF",
    "P-OF",
    "P/OF",
    "RF",
    "SS",
    "UT"
];

const classesFilter = [
    // "All",
    "JR",
    "GR",
    "SO",
    "FR",
    "SR"
];

const teamsFilter = [
    // "All",
    "Abilene Christian",
    "Air Force",
    "Akron",
    "Alabama",
    "Alabama A&M",
    "Alabama State",
    "Albany",
    "Alcorn State",
    "Appalachian State",
    "Arizona",
    "Arizona State",
    "Arkansas",
    "Arkansas State",
    "Arkansas-Pine Bluff",
    "Army",
    "Auburn",
    "BYU",
    "Ball State",
    "Baylor",
    "Bellarmine",
    "Belmont",
    "Bethune-Cookman",
    "Binghamton",
    "Boston College",
    "Bowling Green",
    "Bradley",
    "Bridgewater State",
    "Brown",
    "Bryant",
    "Bucknell",
    "Butler",
    "CSU Bakersfield",
    "Cal Poly",
    "Cal State Fullerton",
    "Cal State Northridge",
    "California",
    "California Baptist",
    "Campbell",
    "Canisius",
    "Central Arizona",
    "Central Arkansas",
    "Central Connecticut",
    "Central Michigan",
    "Central Missouri",
    "Chandler-Gilbert",
    "Charleston Southern",
    "Charlotte",
    "Chattanooga State",
    "Cincinnati",
    "Clemson",
    "Coastal Carolina",
    "College of Charleston",
    "Columbia",
    "Connecticut",
    "Coppin State",
    "Cornell",
    "Creighton",
    "Dallas Baptist",
    "Dartmouth",
    "Davidson",
    "Dayton",
    "Delaware",
    "Dodge City",
    "Duke",
    "East Carolina",
    "East Tennessee State",
    "Eastern Florida State",
    "Eastern Illinois",
    "Eastern Kentucky",
    "Eastern Michigan",
    "Elon",
    "Evansville",
    "FGCU",
    "Fairleigh Dickinson",
    "Flagler",
    "Florence-Darlington Tech",
    "Florida",
    "Florida A&M",
    "Florida Atlantic",
    "Florida International",
    "Florida State",
    "Fordham",
    "Fort Scott",
    "Fort Wayne",
    "Fresno State",
    "Gardner-Webb",
    "George Mason",
    "George Washington",
    "Georgetown",
    "Georgia",
    "Georgia Southern",
    "Georgia State",
    "Georgia Tech",
    "Gonzaga",
    "Grambling",
    "Grand Canyon",
    "Harvard",
    "Hawaii",
    "High Point",
    "Hofstra",
    "Holy Cross",
    "Houston",
    "Houston Christian",
    "Howard (TX)",
    "Illinois",
    "Illinois State",
    "Illinois-Chicago",
    "Incarnate Word",
    "Indiana",
    "Indiana State",
    "Iona",
    "Iowa",
    "Jackson State",
    "Jacksonville",
    "Jacksonville State",
    "James Madison",
    "Kansas",
    "Kansas State",
    "Kansas Wesleyan",
    "Kennesaw State",
    "Kent State",
    "Kentucky",
    "LSU",
    "Lafayette",
    "Lamar",
    "Le Moyne",
    "Liberty",
    "Lindenwood",
    "Lipscomb",
    "Little Rock",
    "Long Beach State",
    "Long Island",
    "Longwood",
    "Louisiana",
    "Louisiana Tech",
    "Louisville",
    "Loyola Marymount",
    "Maine",
    "Manhattan",
    "Marist",
    "Marshall",
    "Maryland",
    "McNeese",
    "Memphis",
    "Mercer",
    "Mercyhurst",
    "Merrimack",
    "Miami",
    "Miami (OH)",
    "Miami Dade",
    "Michigan",
    "Michigan State",
    "Middle Tennessee",
    "Midland (TX)",
    "Milwaukee",
    "Minnesota",
    "Mississippi State",
    "Mississippi Valley",
    "Missouri",
    "Missouri State",
    "Missouri-St. Louis",
    "Monmouth",
    "Morehead State",
    "Mount Saint Mary College (NY)",
    "Mount St. Mary's",
    "Murray State",
    "NC State",
    "NJIT",
    "Navarro",
    "Nebraska",
    "Nevada",
    "New Mexico",
    "New Mexico State",
    "New Orleans",
    "Niagara",
    "Nicholls",
    "Norfolk State",
    "North Alabama",
    "North Carolina",
    "North Carolina A&T",
    "North Dakota State",
    "North Florida",
    "Northeastern",
    "Northern Colorado",
    "Northern Illinois",
    "Northern Kentucky",
    "Northern State",
    "Northwest Florida State",
    "Northwestern",
    "Northwestern State",
    "Notre Dame",
    "Oakland",
    "Ohio",
    "Ohio State",
    "Oklahoma City",
    "Oklahoma State",
    "Old Dominion",
    "Ole Miss",
    "Omaha",
    "Oral Roberts",
    "Oregon",
    "Oregon State",
    "Pacific",
    "Penn",
    "Penn State",
    "Pensacola State",
    "Pepperdine",
    "Pfeiffer",
    "Pittsburgh",
    "Point Loma",
    "Portland",
    "Prairie View",
    "Presbyterian",
    "Princeton",
    "Purdue",
    "Queens (NC)",
    "Quinnipiac",
    "Radford",
    "Rice",
    "Richmond",
    "Rider",
    "Rutgers",
    "SIUE",
    "Sacramento State",
    "Sacred Heart",
    "Saint Joseph's",
    "Saint Louis",
    "Saint Mary's (CA)",
    "Saint Peter's",
    "Sam Houston State",
    "Samford",
    "San Diego",
    "San Diego State",
    "San Francisco",
    "San Jacinto",
    "San Jose State",
    "Santa Clara",
    "Seattle",
    "Seminole State (FL)",
    "Seton Hall",
    "Siena",
    "South Alabama",
    "South Carolina",
    "South Dakota State",
    "Southeast Missouri",
    "Southeastern Louisiana",
    "Southern",
    "Southern Illinois",
    "Southern Indiana",
    "Southern Miss",
    "St. Bonaventure",
    "St. John's",
    "St. Thomas (MN)",
    "Stanford",
    "Stephen F. Austin",
    "Stetson",
    "Stonehill",
    "Stony Brook",
    "TCU",
    "Tarleton State",
    "Tennessee",
    "Tennessee Tech",
    "Texas",
    "Texas A&M",
    "Texas A&M-Corpus Christi",
    "Texas Southern",
    "Texas State",
    "Texas Tech",
    "The Citadel",
    "Toledo",
    "Towson",
    "Trinity (TX)",
    "Troy",
    "Tulane",
    "UAB",
    "UC Davis",
    "UC Riverside",
    "UC San Diego",
    "UC Santa Barbara",
    "UCF",
    "UCLA",
    "UL Monroe",
    "UMBC",
    "UMES",
    "UMass",
    "UMass Lowell",
    "UNC Asheville",
    "UNC Greensboro",
    "UNC Wilmington",
    "UNLV",
    "USC",
    "USC Aiken",
    "USC Upstate",
    "USF",
    "UT Arlington",
    "UT Martin",
    "UT Permian Basin",
    "UTRGV",
    "UTSA",
    "University of Indianapolis",
    "Utah",
    "Utah Tech",
    "Utah Valley",
    "VCU",
    "VMI",
    "Valparaiso",
    "Vanderbilt",
    "Villanova",
    "Virginia",
    "Virginia Tech",
    "Wabash Valley",
    "Wagner",
    "Wake Forest",
    "Walters State",
    "Washington",
    "Washington State",
    "West Georgia",
    "West Virginia",
    "Western Carolina",
    "Western Illinois",
    "Western Kentucky",
    "Western Michigan",
    "Western Oklahoma State",
    "Wharton County",
    "Wichita State",
    "William & Mary",
    "Winthrop",
    "Wofford",
    "Wright State",
    "Xavier",
    "Yale",
    "Youngstown State"
];

const MBB_POSITION = [
    "PG",      // Point Guard
    "SG",      // Shooting Guard
    "G",       // Generic Guard (combo of PG/SG)
    "SF",      // Small Forward
    "PF",      // Power Forward
    "F",       // Generic Forward (combo of SF/PF)
    "C",       // Center
]
const MBB_TEAMS = [
    "Lindenwood Lions",
    "Kansas Jayhawks",
    "Arizona State Sun Devils",
    "Furman Paladins",
    "Michigan State Spartans",
    "Siena Saints",
    "Virginia Cavaliers",
    "Indiana Hoosiers",
    "Northeastern Huskies",
    "Kent State Golden Flashes",
    "Texas A&M Aggies",
    "Arizona Wildcats",
    "Arkansas Razorbacks",
    "Duke Blue Devils",
    "Notre Dame Fightin` Irish",
    "Alabama State Hornets",
    "UAB Blazers",
    "Texas Tech Red Raiders",
    "Idaho Vandals",
    "Alcorn State Braves",
    "Valparaiso Beacons",
    "Boise State Broncos",
    "Lehigh Mountain Hawks",
    "Brown Bears",
    "Nicholls State Colonels",
    "Southeastern Louisiana Lions",
    "UCF Knights",
    "Sam Houston State Bearkats",
    "Cincinnati Bearcats",
    "Cal State Northridge Matadors",
    "Colorado Buffaloes",
    "Connecticut Huskies",
    "Central Connecticut Blue Devils",
    "Davidson Wildcats",
    "Illinois State Redbirds",
    "Dayton Flyers",
    "Bethune-Cookman Wildcats",
    "Florida A&M Rattlers",
    "North Carolina State Wolfpack",
    "Florida International Golden Panthers",
    "Fresno State Bulldogs",
    "Louisiana-Lafayette Cajuns",
    "Hawaii Warriors",
    "Eastern Washington Eagles",
    "Idaho State Bengals",
    "Boston University Terriers",
    "Lafayette Leopards",
    "TCU Horned Frogs",
    "Louisiana Tech Bulldogs",
    "Liberty Flames",
    "Maine Black Bears",
    "Middle Tennessee Blue Raiders",
    "Mississippi Valley State Delta Devils",
    "Louisiana-Monroe Warhawks",
    "Missouri State Bears",
    "Bucknell Bison",
    "Murray State Racers",
    "Texas-Arlington Mavericks",
    "New Mexico Lobos",
    "Old Dominion Monarchs",
    "Northern Iowa Panthers",
    "Montana State Bobcats",
    "Pepperdine Waves",
    "Morgan State Bears",
    "Providence Friars",
    "Dartmouth Big Green",
    "Richmond Spiders",
    "Niagara Purple Eagles",
    "Saint Francis (PA) Red Flash",
    "Nebraska Cornhuskers",
    "Saint Louis Billikens",
    "Lamar Cardinals",
    "Samford Bulldogs",
    "Army Black Knights",
    "San Francisco Dons",
    "Loyola Marymount Lions",
    "Santa Clara Broncos",
    "Nevada Wolf Pack",
    "South Carolina Gamecocks",
    "Monmouth Hawks",
    "Saint John`s Red Storm",
    "Rider Broncs",
    "Stanford Cardinal",
    "Tennessee State Tigers",
    "Tennessee Volunteers",
    "Syracuse Orange",
    "Toledo Rockets",
    "Rice Owls",
    "Tulane Green Wave",
    "UC Irvine Anteaters",
    "UCLA Bruins",
    "Howard Bison",
    "Wake Forest Demon Deacons",
    "Georgia Bulldogs",
    "Wichita State Shockers",
    "Saint Mary`s Gaels",
    "Yale Bulldogs",
    "Northern Arizona Lumberjacks",
    "San Diego State Aztecs",
    "North Carolina Tar Heels",
    "Wisconsin Badgers",
    "Oregon Ducks",
    "LSU Tigers",
    "Villanova Wildcats",
    "Mount St. Mary`s Mountaineers",
    "Xavier Musketeers",
    "Penn Quakers",
    "Kentucky Wildcats",
    "George Mason Patriots",
    "Miami (Fla.) Hurricanes",
    "Stetson Hatters",
    "Purdue Boilermakers",
    "Iona Gaels",
    "Seton Hall Pirates",
    "Iowa State Cyclones",
    "California Golden Bears",
    "Houston Cougars",
    "SMU Mustangs",
    "Delaware Blue Hens",
    "Alabama Crimson Tide",
    "Appalachian State Mountaineers",
    "Arkansas State Red Wolves",
    "Texas Southern Tigers",
    "Auburn Tigers",
    "Green Bay Phoenix",
    "Austin Peay Governors",
    "Utah State Aggies",
    "BYU Cougars",
    "Western Illinois Leathernecks",
    "Butler Bulldogs",
    "Campbell Fightin Camels",
    "Maryland-Baltimore County Retrievers",
    "Clemson Tigers",
    "Princeton Tigers",
    "Cleveland State Vikings",
    "Colorado State Rams",
    "Towson Tigers",
    "Hartford Hawks",
    "DePaul Blue Demons",
    "Navy Midshipmen",
    "Fordham Rams",
    "Bradley Braves",
    "Georgia Southern Eagles",
    "Citadel Bulldogs",
    "Georgia State Panthers",
    "Georgia Tech Yellow Jackets",
    "Harvard Crimson",
    "Jackson State Tigers",
    "Marist Red Foxes",
    "James Madison Dukes",
    "Akron Zips",
    "Kansas State Wildcats",
    "George Washington Revolutionaries",
    "Loyola Maryland Greyhounds",
    "Hofstra Pride",
    "Manhattan Jaspers",
    "Saint Francis (NY) Terriers",
    "Maryland-Eastern Shore Hawks",
    "Evansville Purple Aces",
    "Miami (Ohio) Redhawks",
    "Pacific Tigers",
    "Montana Grizzlies",
    "Illinois Fighting Illini",
    "Long Beach State 49ers",
    "North Texas Mean Green",
    "Colgate Raiders",
    "Oklahoma State Cowboys",
    "Drexel Dragons",
    "Penn State Nittany Lions",
    "Florida Gators",
    "South Florida Bulls",
    "Chicago State Cougars",
    "Southern California Trojans",
    "Western Kentucky Hilltoppers",
    "Southern Illinois Salukis",
    "Southern Utah Thunderbirds",
    "Grambling Tigers",
    "Texas-Rio Grande Valley Vaqueros",
    "Texas State Bobcats",
    "Texas-San Antonio Roadrunners",
    "Coppin State Eagles",
    "Tulsa Golden Hurricane",
    "New Hampshire Wildcats",
    "Virginia Commonwealth Rams",
    "Virginia Military Institute Keydets",
    "Virginia Tech Hokies",
    "Fairleigh Dickinson Knights",
    "Portland Pilots",
    "Washington Huskies",
    "Prairie View Panthers",
    "Weber State Wildcats",
    "Loyola Chicago Ramblers",
    "Western Michigan Broncos",
    "Coastal Carolina Chanticleers",
    "Wright State Raiders",
    "Marshall Thundering Herd",
    "Wyoming Cowboys",
    "UNLV Runnin Rebels",
    "Cornell Big Red",
    "Georgetown Hoyas",
    "Boston College Eagles",
    "San Jose State Spartans",
    "UC Santa Barbara Gauchos",
    "Drake Bulldogs",
    "Long Island Sharks",
    "Eastern Michigan Eagles",
    "Fairfield Stags",
    "Gonzaga Bulldogs",
    "Chattanooga Mocs",
    "Missouri Tigers",
    "New Mexico State Aggies",
    "New Orleans Privateers",
    "Air Force Falcons",
    "Youngstown State Penguins",
    "Florida State Seminoles",
    "South Alabama Jaguars",
    "Texas Longhorns",
    "Oklahoma Sooners",
    "Eastern Illinois Panthers",
    "Baylor Bears",
    "Illinois-Chicago Flames",
    "Iowa Hawkeyes",
    "Vanderbilt Commodores",
    "Winthrop Eagles",
    "Bowling Green Falcons",
    "Ball State Cardinals",
    "Central Michigan Chippewas",
    "Creighton Bluejays",
    "Holy Cross Crusaders",
    "East Tennessee State Buccaneers",
    "Wagner Seahawks",
    "Indiana State Sycamores",
    "Charleston Southern Buccaneers",
    "Marquette Golden Eagles",
    "Memphis Tigers",
    "Minnesota Golden Gophers",
    "Mississippi Rebels",
    "Missouri-Kansas City Kangaroos",
    "Cal State Fullerton Titans",
    "Stephen F. Austin Lumberjacks",
    "UNC Wilmington Seahawks",
    "Northern Illinois Huskies",
    "Northwestern Wildcats",
    "Ohio Bobcats",
    "Pittsburgh Panthers",
    "Rhode Island Rams",
    "Detroit Titans",
    "Northwestern State Demons",
    "Southern Mississippi Golden Eagles",
    "William & Mary Tribe",
    "Duquesne Dukes",
    "West Virginia Mountaineers",
    "Utah Utes",
    "Ohio State Buckeyes",
    "Louisville Cardinals",
    "Maryland Terrapins",
    "Jacksonville Dolphins",
    "Washington State Cougars",
    "Arkansas-Little Rock Trojans",
    "Saint Bonaventure Bonnies",
    "Charlotte 49ers",
    "Radford Highlanders",
    "South Carolina State Bulldogs",
    "Delaware State Hornets",
    "Rutgers Scarlet Knights",
    "Massachusetts Minutemen",
    "Mississippi State Bulldogs",
    "UNC Asheville Bulldogs",
    "Robert Morris Colonials",
    "Saint Joseph`s Hawks",
    "Eastern Kentucky Colonels",
    "La Salle Explorers",
    "Temple Owls",
    "UTEP Miners",
    "Saint Peter`s Peacocks",
    "Oregon State Beavers",
    "Canisius Golden Griffins",
    "East Carolina Pirates",
    "Mercer Bears",
    "Columbia Lions",
    "North Carolina A&T Aggies",
    "McNeese State Cowboys",
    "Morehead State Eagles",
    "San Diego Toreros",
    "Tennessee Tech Golden Eagles",
    "Vermont Catamounts",
    "Western Carolina Catamounts",
    "American Eagles",
    "Michigan Wolverines",
    "Southern Jaguars",
    "Milwaukee Panthers",
    "Sacramento State Hornets",
    "Buffalo Bulls",
    "College of Charleston Cougars",
    "Southeast Missouri State Redhawks",
    "UNC Greensboro Spartans",
    "Tennessee-Martin Skyhawks",
    "Florida Atlantic Owls",
    "Oral Roberts Golden Eagles",
    "Troy Trojans",
    "Cal Poly Mustangs",
    "Hampton Pirates",
    "Jacksonville State Gamecocks",
    "Wofford Terriers",
    "Norfolk State Spartans",
    "Portland State Vikings",
    "Arkansas-Pine Bluff Golden Lions",
    "Denver Pioneers",
    "IUPUI Jaguars",
    "Quinnipiac Bobcats",
    "Elon Phoenix",
    "Albany Great Danes",
    "Oakland Golden Grizzlies",
    "Sacred Heart Pioneers",
    "Belmont Bruins",
    "High Point Panthers",
    "Alabama A&M Bulldogs",
    "Stony Brook Seawolves",
    "Binghamton Bearcats",
    "UC Riverside Highlanders",
    "Fort Wayne Mastodons",
    "Texas A&M-Corpus Christi Islanders",
    "Gardner-Webb Runnin Bulldogs",
    "Lipscomb Bisons",
    "Longwood Lancers",
    "Northern Colorado Bears",
    "UC Davis Aggies",
    "South Dakota State Jackrabbits",
    "North Dakota State Bison",
    "Kennesaw State Owls",
    "Utah Valley Wolverines",
    "NJIT Highlanders",
    "North Florida Ospreys",
    "Seattle Redhawks",
    "Florida Gulf Coast Eagles",
    "Bryant Bulldogs",
    "South Dakota Coyotes",
    "North Carolina Central Eagles",
    "North Dakota Fighting Hawks",
    "Cal State Bakersfield Roadrunners",
    "SIU Edwardsville Cougars",
    "Presbyterian Blue Hose",
    "Central Arkansas Bears",
    "South Carolina Upstate Spartans",
    "Houston Christian Huskies",
    "Omaha Mavericks",
    "Northern Kentucky Norse",
    "Grand Canyon Antelopes",
    "Massachusetts-Lowell River Hawks",
    "Abilene Christian Wildcats",
    "Incarnate Word Cardinals",
    "Colby-Sawyer",
    "California Baptist Lancers",
    "North Alabama Lions",
    "Merrimack Warriors",
    "Bellarmine Knights",
    "Tarleton State Texans",
    "UC San Diego Tritons",
    "Utah Tech Trailblazers",
    "Queens (N.C.) Royals",
    "Texas A&M-Commerce Lions",
    "Southern Indiana Screaming Eagles",
    "Stonehill Skyhawks",
    "Saint Thomas (Minn.) Tommies",
    "Le Moyne Dolphins",
    "Mercyhurst Lakers",
    "West Georgia Wolves"
]
const positionsBaseball = [
    { id: 'all', label: 'All Positions' },
    { id: 'C', label: 'Catcher' },
    { id: '1B', label: 'First Base' },
    { id: '2B', label: 'Second Base' },
    { id: '3B', label: 'Third Base' },
    { id: 'SS', label: 'Shortstop' },
    { id: 'OF', label: 'Outfielder' },
    { id: 'LF', label: 'Left Field' },
    { id: 'CF', label: 'Center Field' },
    { id: 'RF', label: 'Right Field' },
    { id: 'DH', label: 'DH' },
    { id: 'RHP', label: 'RH Pitcher' },
    { id: 'LHP', label: 'LH Pitcher' }
];

const positionsMBB = [
    { id: 'all', label: 'All' },
    // { id: 'ATH', label: 'Athlete' },
    { id: 'C', label: 'Center' },
    // { id: 'F', label: 'Forward' },
    // { id: 'G', label: 'Guard' },
    { id: 'PF', label: 'Power Forward' },
    { id: 'PG', label: 'Point Guard' },
    { id: 'SF', label: 'Small Forward' },
    { id: 'SG', label: 'Shooting Guard' }
];
const parseFloat = (value, defaultValue = 0) => {
    const parsed = Number(value);
    return isNaN(parsed) ? defaultValue : Number(parsed.toFixed(1));
};

const parseInt = (value, defaultValue = 0) => {
    const parsed = Number(value);
    return isNaN(parsed) ? defaultValue : Math.round(parsed);
};

const formatHeight = (heightInches) => {
    const inches = parseFloat(heightInches);
    if (inches === 0) return "N/A";
    const feet = Math.floor(inches / 12);
    const remainingInches = Math.round(inches % 12);
    return `${feet}'${remainingInches}"`;
};

const formatWeight = (weight) => {
    const lbs = parseFloat(weight);
    return lbs === 0 ? "" : `${lbs}`;
};

const parsePlayerData = (data) => {
    const metrics = {
        // Basic info
        name: data.player || "Unknown Player",
        team: data.team || "Unknown Team",
        Player: data.player || "Unknown Player",
        newTeam: data.new_team || data.team,
        class: data.class || "N/A",
        position: data.position || "N/A",
        height: data.height,
        weight: data.weight,
        rank: data.Rank || "N/A",

        // BPR metrics
        obprPrev: parseFloat(data.obpr_prev),
        dbprPrev: parseFloat(data.dbpr_prev),
        bprPrev: parseFloat(data.bpr_prev),
        obprPredicted: parseFloat(data.obpr_prev),
        dbprPredicted: parseFloat(data.dbpr_prev),
        bprPredicted: parseFloat(data.bpr_prev),

        // Team metrics
        plusMinus: parseFloat(data.plus_minus),
        teamOffEff: parseFloat(data.adj_team_off_eff),
        teamDefEff: parseFloat(data.adj_team_def_eff),
        teamEffMargin: parseFloat(data.adj_team_eff_margin),
        possessions: parseInt(data.poss),

        // Shooting metrics
        threePointPct: parseFloat(data.value_three_pct),
        twoPointPct: parseFloat(data.value_two_pct),
        ftPct: parseFloat(data.value_ft_pct),
        scoring: parseFloat(data.value_scoring),

        // Playmaking metrics
        assistRate: parseFloat(data.value_assist_rate),
        turnoverRate: parseFloat(data.value_TO),
        playmaking: parseFloat(data.value_playmaking),

        // Rebounding metrics
        orebPct: parseFloat(data.value_oreb_pct),
        drebPct: parseFloat(data.value_dreb_pct),
        rebPct: parseFloat(data.value_reb_pct),

        // Defensive metrics
        blockPct: parseFloat(data.value_blk_pct),
        stealRate: parseFloat(data.value_STL),
        personalFouls: parseFloat(data.value_PF),
        defensiveValue: parseFloat(data.value_D),
        hdi_data: data?.hdi_data,
        assistToTurnover: parseFloat(data.value_TO),
        effective_field_goal_percentage: parseFloat(data?.core_stats?.effective_field_goal_percentage),
        field_goal_percentage: parseFloat(data?.core_stats?.field_goal_percentage),
        Eff: parseFloat(data?.core_stats?.efficiency),
        games: parseFloat(data?.core_stats?.games),
        minutes_per_game: parseFloat(data?.core_stats?.minutes_per_game),
        points_per_game: parseFloat(data?.core_stats?.points_per_game),
        fouls_per_game: parseFloat(data?.core_stats?.fouls_per_game),
        turnovers_per_game: parseFloat(data?.core_stats?.turnovers_per_game),
        steals_per_game: parseFloat(data?.core_stats?.steals_per_game),
        blocks_per_game: parseFloat(data?.core_stats?.blocks_per_game),
        rebounds_per_game: parseFloat(data?.core_stats?.rebounds_per_game),
        assists_per_game: parseFloat(data?.core_stats?.assists_per_game),
        core_stats: data?.core_stats,
        // Colors from API
        colors: {
            offensive: data.color_O_pred || '#FFDDB3',
            defensive: data.color_D_pred || '#F4F8FB',
            threePoint: data.color_three_pct || '#FFD7A5',
            twoPoint: data.color_two_pct || '#FFFFFF',
            freeThrow: data.color_ft_pct || '#FFFFFF',
            scoring: data.color_scoring || '#FFEBD2',
            assist: data.color_assist_rate || '#DCE9F5',
            turnover: data.color_TO || '#FFFFFF',
            playmaking: data.color_playmaking || '#FFFFFF',
            oreb: data.color_oreb_pct || '#FFFFFF',
            dreb: data.color_dreb_pct || '#FFEBD2',
            reb: data.color_reb_pct || '#FFFFFF',
            block: data.color_blk_pct || '#FFFFFF',
            steal: data.color_STL || '#CBDEF0',
            fouls: data.color_PF || '#FFFFFF',
            defense: data.color_D || '#FFFFFF'
        },

        // Calculated metrics
        slamScore: data?.slamScore || 0,
    };
    return metrics
}

  // ============================================================================
  // SPORT-SPECIFIC SAMPLE QUESTIONS
  // ============================================================================

  // College basketball sample questions (MBB, WBB)
  const COLLEGE_BASKETBALL_SAMPLE_QUESTIONS = [
    { id: 1, question: "Show me AJ Storr's stats", category: "player" },
    { id: 2, question: "Find guards scoring 15+ PPG", category: "search" },
    { id: 3, question: "Top 10 rebounders in portal", category: "search" },
    { id: 4, question: "Kansas transfer portal players", category: "team" },
    { id: 5, question: "Centers over 6'10\" available", category: "search" },
    { id: 6, question: "Best 3PT shooters (40%+)", category: "search" },
    { id: 7, question: "SEC guards in transfer portal", category: "conference" },
    { id: 8, question: "Compare Duke vs Kentucky guards", category: "compare" },
    { id: 9, question: "Players with 5+ assists/game", category: "search" },
    { id: 10, question: "Big 12 forwards under 6'8\"", category: "search" },
    { id: 11, question: "Show uncommitted point guards", category: "search" },
    { id: 12, question: "ACC shooters 38%+ from 3", category: "conference" },
    { id: 13, question: "Players averaging double-double", category: "search" },
    { id: 14, question: "Freshman guards available", category: "search" },
    { id: 15, question: "Export Big Ten guards to Excel", category: "export" },
  ];

  // NBA pro basketball sample questions
  const NBA_SAMPLE_QUESTIONS = [
    { id: 1, question: "Show me Hawks roster stats", category: "team" },
    { id: 2, question: "Find guards scoring 20+ PPG", category: "search" },
    { id: 3, question: "Top 10 rebounders in the league", category: "search" },
    { id: 4, question: "Hawks player analysis", category: "team" },
    { id: 5, question: "Centers with highest PER", category: "search" },
    { id: 6, question: "Best 3PT shooters (40%+)", category: "search" },
    { id: 7, question: "Eastern Conference guards", category: "conference" },
    { id: 8, question: "Compare Hawks vs Celtics rosters", category: "compare" },
    { id: 9, question: "Players with 7+ assists/game", category: "search" },
    { id: 10, question: "Top defenders by DBPM", category: "search" },
    { id: 11, question: "Rising stars under 25", category: "search" },
    { id: 12, question: "Elite shooters by true shooting", category: "search" },
    { id: 13, question: "Players averaging triple-double", category: "search" },
    { id: 14, question: "Best plus/minus in playoffs", category: "search" },
    { id: 15, question: "Export team stats to Excel", category: "export" },
  ];

  // Alias for backwards compatibility
  const BASKETBALL_SAMPLE_QUESTIONS = COLLEGE_BASKETBALL_SAMPLE_QUESTIONS;

  // College baseball sample questions (CBB)
  const COLLEGE_BASEBALL_SAMPLE_QUESTIONS = [
    { id: 1, question: "Show me pitcher stats from Vanderbilt", category: "team" },
    { id: 2, question: "Find RHP throwing 95+ mph", category: "search" },
    { id: 3, question: "Top 10 hitters by batting avg", category: "search" },
    { id: 4, question: "LSU transfer portal players", category: "team" },
    { id: 5, question: "Catchers with strong arms", category: "search" },
    { id: 6, question: "Best OPS in the SEC", category: "search" },
    { id: 7, question: "ACC pitchers with low ERA", category: "conference" },
    { id: 8, question: "Compare Texas vs Florida rosters", category: "compare" },
    { id: 9, question: "Players with 50+ RBIs", category: "search" },
    { id: 10, question: "Left-handed pitchers available", category: "search" },
    { id: 11, question: "Uncommitted shortstops", category: "search" },
    { id: 12, question: "Pitchers with 100+ strikeouts", category: "search" },
    { id: 13, question: "Analyze pitcher mechanics", category: "analysis" },
    { id: 14, question: "Check for pitch tipping tells", category: "analysis" },
    { id: 15, question: "Export Big 12 pitchers to Excel", category: "export" },
  ];

  // MLB pro baseball sample questions
  const MLB_SAMPLE_QUESTIONS = [
    { id: 1, question: "Show me Yankees pitcher stats", category: "team" },
    { id: 2, question: "Find RHP throwing 97+ mph", category: "search" },
    { id: 3, question: "Top 10 hitters by batting avg", category: "search" },
    { id: 4, question: "Orioles roster analysis", category: "team" },
    { id: 5, question: "Catchers with highest framing runs", category: "search" },
    { id: 6, question: "Best OPS in the AL East", category: "search" },
    { id: 7, question: "Pitchers with sub-3.00 ERA", category: "search" },
    { id: 8, question: "Compare Yankees vs Orioles rosters", category: "compare" },
    { id: 9, question: "Players with 80+ RBIs", category: "search" },
    { id: 10, question: "Left-handed pitchers analysis", category: "search" },
    { id: 11, question: "Top closers by save percentage", category: "search" },
    { id: 12, question: "Pitchers with 180+ strikeouts", category: "search" },
    { id: 13, question: "Analyze pitcher biomechanics", category: "analysis" },
    { id: 14, question: "Detect pitch tipping tells", category: "analysis" },
    { id: 15, question: "Export division stats to Excel", category: "export" },
  ];

  // Alias for backwards compatibility
  const BASEBALL_SAMPLE_QUESTIONS = COLLEGE_BASEBALL_SAMPLE_QUESTIONS;

  // Football sample questions
  const FOOTBALL_SAMPLE_QUESTIONS = [
    { id: 1, question: "Show me top QBs by passing yards", category: "search" },
    { id: 2, question: "Compare rushing leaders in SEC", category: "compare" },
    { id: 3, question: "Top 10 receivers by yards/catch", category: "search" },
    { id: 4, question: "Alabama defensive stats breakdown", category: "team" },
    { id: 5, question: "Find RBs with 1000+ rush yards", category: "search" },
    { id: 6, question: "QB passer rating leaders", category: "search" },
    { id: 7, question: "Big 10 team standings", category: "conference" },
    { id: 8, question: "Compare Ohio State vs Michigan rosters", category: "compare" },
    { id: 9, question: "Players with 10+ sacks", category: "search" },
    { id: 10, question: "Top interception leaders", category: "search" },
    { id: 11, question: "Analyze team red zone efficiency", category: "analysis" },
    { id: 12, question: "Play-by-play breakdown last game", category: "analysis" },
    { id: 13, question: "Third down conversion leaders", category: "search" },
    { id: 14, question: "Top punt returners by average", category: "search" },
    { id: 15, question: "Export conference stats to Excel", category: "export" },
  ];

  // Soccer sample questions
  const SOCCER_SAMPLE_QUESTIONS = [
    { id: 1, question: "Show me top scorers this season", category: "search" },
    { id: 2, question: "Compare assist leaders", category: "compare" },
    { id: 3, question: "Team goals per game ranking", category: "search" },
    { id: 4, question: "Goalkeeper save percentage leaders", category: "search" },
    { id: 5, question: "Players with most minutes played", category: "search" },
    { id: 6, question: "Yellow card leaders by team", category: "search" },
    { id: 7, question: "Clean sheet leaders", category: "search" },
    { id: 8, question: "Compare team defensive records", category: "compare" },
    { id: 9, question: "Top midfielders by pass completion", category: "search" },
    { id: 10, question: "Analyze team possession stats", category: "analysis" },
  ];

  // Hockey sample questions
  const HOCKEY_SAMPLE_QUESTIONS = [
    { id: 1, question: "Show me top scorers this season", category: "search" },
    { id: 2, question: "Compare goalie save percentages", category: "compare" },
    { id: 3, question: "Top 10 players by points", category: "search" },
    { id: 4, question: "Power play efficiency leaders", category: "search" },
    { id: 5, question: "Find defensemen with 30+ points", category: "search" },
    { id: 6, question: "Plus/minus leaders", category: "search" },
    { id: 7, question: "Division standings", category: "conference" },
    { id: 8, question: "Compare teams by penalty kill %", category: "compare" },
    { id: 9, question: "Players with most hits", category: "search" },
    { id: 10, question: "Analyze team faceoff percentages", category: "analysis" },
  ];

  // Formula 1 sample questions
  const F1_SAMPLE_QUESTIONS = [
    { id: 1, question: "Show current driver standings", category: "search" },
    { id: 2, question: "Compare lap times at Monaco", category: "compare" },
    { id: 3, question: "Constructor championship standings", category: "search" },
    { id: 4, question: "Fastest pit stops this season", category: "search" },
    { id: 5, question: "Race results from last Grand Prix", category: "search" },
    { id: 6, question: "Driver career wins comparison", category: "compare" },
    { id: 7, question: "Analyze qualifying pace trends", category: "analysis" },
    { id: 8, question: "Weather impact on race outcomes", category: "analysis" },
    { id: 9, question: "Tire strategy analysis by circuit", category: "analysis" },
    { id: 10, question: "DNF statistics by constructor", category: "search" },
  ];

  // PGA Golf sample questions
  const PGA_SAMPLE_QUESTIONS = [
    { id: 1, question: "Show current tournament leaderboard", category: "search" },
    { id: 2, question: "Compare player scoring averages", category: "compare" },
    { id: 3, question: "Top 10 by driving distance", category: "search" },
    { id: 4, question: "FedEx Cup standings", category: "search" },
    { id: 5, question: "Greens in regulation leaders", category: "search" },
    { id: 6, question: "Round scores for last tournament", category: "search" },
    { id: 7, question: "Course stats for Augusta National", category: "search" },
    { id: 8, question: "Putting average leaders", category: "search" },
    { id: 9, question: "Compare players on par-5 scoring", category: "compare" },
    { id: 10, question: "Season stats for top money earners", category: "search" },
  ];

  // Default (legacy) - kept for backwards compatibility
  const SAMPLE_QUESTIONS = BASKETBALL_SAMPLE_QUESTIONS;

  /**
   * Get sport-specific sample questions
   * @param {string} sport - Sport code (MBB, WBB, NBA, CBB, MLB, CFB, PFB, FC, NHL, F1, PGA)
   * @returns {Array} Sport-specific sample questions
   */
  const getSportSpecificQuestions = (sport) => {
    // Pro sports get pro-specific questions (no college/transfer portal references)
    if (sport === 'MLB') {
      return MLB_SAMPLE_QUESTIONS;
    }
    if (sport === 'NBA') {
      return NBA_SAMPLE_QUESTIONS;
    }

    // College baseball
    if (sport === 'CBB' || sport === 'baseball') {
      return COLLEGE_BASEBALL_SAMPLE_QUESTIONS;
    }

    // College basketball (MBB, WBB)
    if (sport === 'MBB' || sport === 'WBB' || sport === 'basketball') {
      return COLLEGE_BASKETBALL_SAMPLE_QUESTIONS;
    }

    // EuroLeague and professional international basketball
    if (sport === 'EURO' || sport === 'GL' || sport === 'WNBA') {
      return NBA_SAMPLE_QUESTIONS; // Pro basketball questions work for these leagues
    }

    // Football
    if (sport === 'CFB' || sport === 'PFB' || sport === 'football') {
      return FOOTBALL_SAMPLE_QUESTIONS;
    }

    // Soccer
    if (sport === 'FC' || sport === 'soccer') {
      return SOCCER_SAMPLE_QUESTIONS;
    }

    // Hockey
    if (sport === 'NHL' || sport === 'MiLH' || sport === 'hockey') {
      return HOCKEY_SAMPLE_QUESTIONS;
    }

    // Formula 1
    if (sport === 'F1' || sport === 'formula1') {
      return F1_SAMPLE_QUESTIONS;
    }

    // Golf
    if (sport === 'PGA' || sport === 'golf') {
      return PGA_SAMPLE_QUESTIONS;
    }

    // Default to college basketball
    return COLLEGE_BASKETBALL_SAMPLE_QUESTIONS;
  };

  /**
   * Check if a sport is baseball-related
   * @param {string} sport - Sport code
   * @returns {boolean}
   */
  const isBaseballSport = (sport) => {
    return ['CBB', 'MLB', 'MiLB', 'KBO', 'NPB', 'baseball'].includes(sport);
  };

  /**
   * Check if a sport is basketball-related
   * @param {string} sport - Sport code
   * @returns {boolean}
   */
  const isBasketballSport = (sport) => {
    return ['MBB', 'WBB', 'NBA', 'WNBA', 'EURO', 'GL', 'MB2', 'WB2', 'EuroBB', 'AsiaBB', 'AmerBB', 'WBPro', 'basketball'].includes(sport);
  };

  /**
   * Check if a sport is hockey-related
   */
  const isHockeySport = (sport) => {
    return ['NHL', 'MiLH', 'MHK', 'WHK', 'KHL', 'hockey'].includes(sport);
  };

  /**
   * Check if a sport is football-related
   */
  const isFootballSport = (sport) => {
    return ['PFB', 'CFB', 'NFL', 'football'].includes(sport);
  };

  /**
   * Check if a sport is soccer-related
   */
  const isSoccerSport = (sport) => {
    return ['FC', 'soccer'].includes(sport);
  };

  /**
   * Check if a sport is Formula 1-related
   */
  const isF1Sport = (sport) => {
    return ['F1', 'formula1'].includes(sport);
  };

  /**
   * Check if a sport is golf-related
   */
  const isGolfSport = (sport) => {
    return ['PGA', 'golf'].includes(sport);
  };

  /**
   * Get the sport category from a league/sport code.
   * Returns: 'basketball' | 'baseball' | 'hockey' | 'football' | 'soccer' | 'f1' | 'golf' | null
   */
  const getSportCategory = (sport) => {
    if (isBasketballSport(sport)) return 'basketball';
    if (isBaseballSport(sport)) return 'baseball';
    if (isHockeySport(sport)) return 'hockey';
    if (isFootballSport(sport)) return 'football';
    if (isSoccerSport(sport)) return 'soccer';
    if (isF1Sport(sport)) return 'f1';
    if (isGolfSport(sport)) return 'golf';
    return null;
  };

  /**
   * Check if a sport has live data tools available (BigQuery data)
   */
  const hasLiveData = (sport) => {
    return getSportCategory(sport) !== null;
  };

export {
    googleClientId,
    NODE_BACKEND_URL,
    PYTHON_BACKEND_URL,
    teamsFilter,
    positionsFilter,
    classesFilter,
    APP_ID,
    DEVELOPER_KEY,
    MBB_POSITION,
    formatHeight,
    formatWeight,
    MBB_TEAMS,
    positionsBaseball,
    positionsMBB,
    parsePlayerData,
    ADK_BACKEND_URL,
    WIDGET_BACKEND_URL,
    AGUI_RUNTIME,
    parseFloat,
    SAMPLE_QUESTIONS,
    BASKETBALL_SAMPLE_QUESTIONS,
    BASEBALL_SAMPLE_QUESTIONS,
    COLLEGE_BASKETBALL_SAMPLE_QUESTIONS,
    COLLEGE_BASEBALL_SAMPLE_QUESTIONS,
    MLB_SAMPLE_QUESTIONS,
    NBA_SAMPLE_QUESTIONS,
    FOOTBALL_SAMPLE_QUESTIONS,
    SOCCER_SAMPLE_QUESTIONS,
    HOCKEY_SAMPLE_QUESTIONS,
    F1_SAMPLE_QUESTIONS,
    PGA_SAMPLE_QUESTIONS,
    getSportSpecificQuestions,
    isBaseballSport,
    isBasketballSport,
    isHockeySport,
    isFootballSport,
    isSoccerSport,
    isF1Sport,
    isGolfSport,
    getSportCategory,
    hasLiveData
}
